<template>
  <div class="container-fluid" style="margin-top:30px">
    <div class="category-list">
      <carousel
        :perPage="1"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :perPageCustom="[[768, 1], [1024, 4]]"
        class="VueCarousel"
      >
        <slide
          v-for="onecat in allcategory"
          :key="onecat.id"
          class="col-md-3 col-sm-4 col-lg-4 col-xs-6 p-1 product-box"
        >
          <router-link :to="'/cat/' + onecat.id">
            <div class="card uppercat">
              <img class="card-img-top" style="" :src="onecat.image" />
              <div class="catname-custom">
                <p style="font-size: 20px; font-weight: bold">
                  {{ onecat.name }}
                </p>
              </div>
            </div>
          </router-link>
        </slide>
      </carousel>
    </div>
    <br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dbFs } from "@/modules/database";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  },
  data: () => {
    return {
      allcategory: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.getcategory();
  },
  methods: {
    getcategory() {
      this.$bind("allcategory", dbFs.collection("productCategory")).then(
        () => {}
      );
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");

/* new stylings */
.uppercat {
  position: relative;
}
.catname-custom {
  height: 40px;
  padding: 7px 0;
  position: absolute;
  text-align: center;
  bottom: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.578);
  color: rgb(0, 0, 0);
  padding-left: 20px;
  padding-right: 20px;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #51381b;
  opacity: 0;
  overflow: hidden;
  width: 92.5%;
  height: 100%;
  transition: 1s ease;
  margin-left: 12px;
}

.wrapper:hover .overlay {
  opacity: 0.8;
}

.category-background {
  width: 92.5%;
  background-color: #b3b3b3af;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: 12px;
  padding: 7px;
}
.category-background-else {
  width: 91.5%;
  background-color: #b3b3b3af;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: 12px;
  padding: 7px;
}

.head-font {
  font-size: 1.3em;
  font-weight: bold;
  color: #000000;
  letter-spacing: -0.5px;
  text-align: center;
}

.para {
  font-size: 1em;
  font-family: "Montserrat-Regular";
  color: #ffffff;
  letter-spacing: 0.51px;
  text-align: center;
}

.category-img {
  display: block;
  width: 100%;
  height: 250px;
}

.wrapper {
  /* position: relative; */
}

/* with user css */
.overlay-else {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #51381b;
  opacity: 0;
  overflow: hidden;
  width: 91%;
  height: 100%;
  transition: 1s ease;
  margin-left: 12px;
}

.wrapper:hover .overlay-else {
  opacity: 0.8;
}

@media only screen and (max-width: 500px) {
  .overlay-else {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #51381b;
    opacity: 0;
    overflow: hidden;
    width: 92.5%;
    height: 100%;
    transition: 1s ease;
    margin-left: 12px;
  }

  .wrapper:hover .overlay-else {
    opacity: 0.8;
  }

  .category-background-else {
    width: 92.5%;
    height: 75px;
    background-color: #1c1a1a;
    opacity: 0.8;
    border-radius: 33px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-bottom: 25%;
    margin-left: 12px;
    padding: 7px;
  }
}
</style>
